
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TGenericObject } from '@/types/base'
@Component
export default class ShowcaseDocuments extends Vue {
  @Prop({ required: true }) documents: TGenericObject[]
}
